<router-outlet></router-outlet>
<div class="footer">
    <div>{{ appName }} v{{ version }}</div>
    <div [innerHTML]="copyright"></div>
</div>